import React, { Component } from 'react';
import { Chart } from 'primereact/chart';

class PieChart extends Component {
    constructor(props) {
        super(props);
        var data = JSON.parse(this.props.values);

        this.state = {
            data: data
        };
    }

    render() {
        const lightOptions = {
            labels: {
                fontColor: '#495057'
            }
        };

        return (
            <div className="card">
                <Chart type="pie" data={this.state.data} options={lightOptions} />
            </div>
        )
    }
}

export default PieChart;